exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "::-webkit-scrollbar {\r\n    width: 5px;\r\n  }\r\n  \r\n  /* Track */\r\n  ::-webkit-scrollbar-track {\r\n    background: black; \r\n  }\r\n   \r\n  /* Handle */\r\n  ::-webkit-scrollbar-thumb {\r\n    background: #f1f1f1; \r\n  }\r\n  \r\n  /* Handle on hover */\r\n  ::-webkit-scrollbar-thumb:hover {\r\n    background: white; \r\n  }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/oomph/oom-payments/oom-payments.component.css
// module id = ../../../../../src/app/components/oomph/oom-payments/oom-payments.component.css
// module chunks = main